module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/introduction01-4ede30aeea27d27904bb2c7a50922536.png";